import { createFileRoute } from '@tanstack/react-router'
import { APP_NAME } from '@/lib/utils'
import Statues from '@/features/statuses'

export const Route = createFileRoute('/_authenticated/tracking-states/')({
  component: Statues,
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | États`,
      },
    ],
  }),
  // beforeLoad: async () => {
  //   try {
  //     const res = await getCurrentUser()
  //     if (!res?.id) {
  //       throw redirect({
  //         to: '/sign-in-2',
  //       })
  //     }
  //   } catch (_) {
  //     throw redirect({
  //       to: '/sign-in-2',
  //     })
  //   }
  // },
})
